export default __webpack_public_path__ + "static/media/boyi 1.a2b4555c.png";